import { atob } from '@wix/communities-blog-client-common';

export type ParsedInstance = {
  demoMode: boolean;
  biToken: string;
  uid: string;
  metaSiteId: string;
  siteMemberId: string;
  instanceId: string;
  hasUserRole: boolean;
  aid?: string;
  permissions?: string;
  siteIsTemplate?: string;
};

export const parseInstance = (appToken: string | undefined): ParsedInstance => {
  if (!appToken) {
    throw new Error('Missing instance');
  }

  const [, base64data] = appToken.split('.', 2);
  const data = atob(base64data);

  return JSON.parse(data);
};
